import { Injectable } from '@angular/core';

const STORAGE_KEY = 'selectedAcceptor';

interface ISelectedAcceptor {
  documentId: string;
  iin: string;
}

@Injectable({
  providedIn: 'root'
})
export class SelectedAcceptorService {

  set(documentId: string, iin: string): void {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ documentId, iin }));
    } catch (e) {}
  }

  get(documentId: string): string | null {
    try {
      const saved: ISelectedAcceptor = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      return saved && saved.documentId === documentId ? saved.iin : null;
    } catch (e) {
      return null;
    }
  }

  clear(): void {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }
}
